class UserModel {
  id = null;
  email = '';
}

export default UserModel;
